import type { Encounter, Reference } from "@medplum/fhirtypes";
import { VISIT_ENTITY_ID_SYSTEM } from "@repo/api";
import type { VisitId } from "@repo/domain";

/** Stable Visit identity carried by an Encounter or Appointment reference. */
export function visitDomainId(reference: Reference | undefined): string {
  return reference?.identifier?.system === VISIT_ENTITY_ID_SYSTEM ? (reference.identifier.value ?? "") : "";
}

/** Optimistic Encounter reference; the authoritative mapper resolves its private literal. */
export function optimisticVisitExecutionReference(visitId: VisitId): Reference<Encounter> {
  return { identifier: { system: VISIT_ENTITY_ID_SYSTEM, value: visitId } };
}
